import { z } from "zod/v3";

// Пустое значение в .env означает «не задано», а не ошибочный адрес.
const optionalUrl = z.preprocess(
  (value) => (value === "" ? undefined : value),
  z.string().url().optional(),
);

// Загрузчик КриптоПро хранится в public и должен открываться с того же origin,
// поэтому кроме абсолютного URL разрешаем корневой путь, но не //host/path.
const optionalSameOriginUrl = z.preprocess(
  (value) => (value === "" ? undefined : value),
  z
    .union([
      z.string().url(),
      z.string().regex(/^\/(?!\/)/, "Expected an absolute URL or same-origin path"),
    ])
    .optional(),
);

const environmentSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_WS_URL: z.string().url(),
  VITE_APP_ENV: z.enum(["local", "testing", "staging", "production"]),
  // Адрес cadesplugin_api.js браузерного плагина КриптоПро. Скрипт
  // подключается только по этой настройке.
  VITE_CRYPTOPRO_PLUGIN_URL: optionalSameOriginUrl,
  // Служба штампов времени: без неё доступна только подпись CAdES-BES.
  VITE_CRYPTOPRO_TSA_URL: optionalUrl,
});

export type Environment = z.infer<typeof environmentSchema>;

export function parseEnvironment(values: Record<string, unknown>): Environment {
  return environmentSchema.parse(values);
}

/**
 * Media URLs in Site Content are stored as API-relative paths. Resolve those
 * paths against the configured API origin instead of the ERP frontend origin.
 */
export function resolveApiUrl(
  value: string,
  values: Record<string, unknown> = import.meta.env,
): string {
  if (!value.startsWith("/api/")) return value;

  return new URL(value, parseEnvironment(values).VITE_API_BASE_URL).toString();
}
